import type { EffectivePermissions, PagePermission } from '@/types/auth';

const levels: Record<PagePermission, number> = { none: 0, read: 1, write: 2 };

export function hasPermission(
  permissions: EffectivePermissions | null,
  page: string,
  required: PagePermission = 'read'
): boolean {
  const actual = permissions?.[page] || 'none';
  return levels[actual] >= levels[required];
}

export function firstAllowedRoute(permissions: EffectivePermissions | null): string {
  if (hasPermission(permissions, 'chat', 'read')) return '/chat';
  if (hasPermission(permissions, 'conversations', 'read')) return '/sessions';
  if (hasPermission(permissions, 'knowledge', 'read')) return '/knowledge';
  if (hasPermission(permissions, 'engine', 'read')) return '/ai-core';
  if (hasPermission(permissions, 'config', 'read')) return '/config';
  if (hasPermission(permissions, 'users') || hasPermission(permissions, 'roles')) return '/access';
  return '/forbidden';
}
